import { motion } from "framer-motion";

const painPoints = [
  "Te comparan por precio cuando deberían elegirte por valor.",
  "No reconocen diferenciales que te llevó años construir.",
  "Tu posicionamiento representa lo que fuiste, no hacia dónde vas.",
];

const Challenge = () => {
  return <section className="py-24 md:py-32 relative overflow-hidden bg-background" id="desafio">
      <div className="container px-4">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-4xl mx-auto mb-12">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
            Cuando tu empresa evoluciona pero su percepción no,{" "}
            <span className="text-gradient-gold">empieza a dejar valor sobre la mesa</span>.
          </h2>
        </motion.div>

        {/* Pain points grid */}
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-16">
          {painPoints.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group">
              <div className="bg-card rounded-2xl p-8 h-full border border-border hover:border-primary/30 transition-all duration-300 hover:shadow-lg flex items-center justify-center text-center">
                <p className="font-display text-xl font-semibold text-foreground leading-snug">
                  {point}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Closing statement */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center font-display text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed">
          El deseo es simple: que el mercado vea, entienda y valore la empresa que realmente construiste.
        </motion.p>
      </div>
    </section>;
};
export default Challenge;
